/**
 * v4 header — mobile menu + cart drawer (matches bal-com-v4 Header.tsx behavior).
 */
(function () {
  const header = document.querySelector(".header");
  const menuBtn = document.querySelector(".header__menu-btn");
  const cartBtn = document.querySelector(".header__cart-btn");
  const mobileOverlay = document.getElementById("overlay-mobile");
  const cartOverlay = document.getElementById("overlay-cart");

  /* Move drawer overlays to <body> so section/grid parents cannot clip the footer. */
  [mobileOverlay, cartOverlay].forEach(function (overlay) {
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
  });

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add("expanded");
    document.documentElement.style.overflow = "hidden";
    if (overlay === mobileOverlay && menuBtn) {
      menuBtn.setAttribute("aria-expanded", "true");
    }
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove("expanded");
    if (!document.querySelector(".overlay.expanded")) {
      document.documentElement.style.overflow = "";
    }
    if (overlay === mobileOverlay && menuBtn) {
      menuBtn.setAttribute("aria-expanded", "false");
    }
  }

  /** Sticky nav height (announce bar is outside the sticky stack). */
  function getStickyNavHeight() {
    const stack = document.querySelector(".header-stack");
    const nav = document.querySelector(".header-stack > .header") || document.querySelector(".header");
    return (stack || nav)?.offsetHeight ?? 72;
  }

  function syncHeaderStackHeight() {
    const h = getStickyNavHeight();
    document.documentElement.style.setProperty("--home-sticky-header-h", `${h}px`);
    document.documentElement.style.setProperty("--v4-header-stack-h", `${h}px`);
    document.documentElement.style.setProperty("--v4-pdp-sticky-top", `${h + 24}px`);
  }

  /** Parse "#ourproducts" / "/#ourproducts" / "https://…/#ourproducts" → "ourproducts" */
  function sectionIdFromHref(href) {
    if (!href) return "";
    try {
      const url = new URL(href, window.location.origin);
      const hash = (url.hash || "").replace(/^#/, "");
      return hash || "";
    } catch (err) {
      const m = String(href).match(/#([^?#]+)/);
      return m ? m[1] : "";
    }
  }

  function samePageAsHref(href) {
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname === window.location.pathname;
    } catch (err) {
      return String(href || "").charAt(0) === "#";
    }
  }

  function scrollToSection(id) {
    const target = document.getElementById(id);
    if (!target) return false;
    syncHeaderStackHeight();
    // Align section top with sticky nav bottom border
    const headerHeight = getStickyNavHeight();
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    history.replaceState(null, "", `#${id}`);
    return true;
  }

  menuBtn?.addEventListener("click", () => openOverlay(mobileOverlay));
  cartBtn?.addEventListener("click", () => {
    window.V4ShopifyCart?.refresh?.();
    openOverlay(cartOverlay);
  });

  document.querySelectorAll(".overlay .close-outside, .overlay .close").forEach((btn) => {
    btn.addEventListener("click", () => {
      const overlay = btn.closest(".overlay");
      if (overlay) closeOverlay(overlay);
    });
  });

  document.querySelectorAll("[data-overlay-close]").forEach((el) => {
    el.addEventListener("click", () => {
      const id = el.getAttribute("data-overlay-close");
      const overlay = id ? document.getElementById(id) : el.closest(".overlay");
      if (overlay instanceof HTMLElement) closeOverlay(overlay);
    });
  });

  // Desktop + mobile nav: scroll so sticky header bottom touches section top
  document
    .querySelectorAll(
      ".header__menu-item[href], .header-menu-item[href], .header__nav a[href]:not(.header__nav-link--products)"
    )
    .forEach((link) => {
      link.addEventListener("click", (e) => {
        const href = link.getAttribute("href") || "";
        const id = sectionIdFromHref(href);
        if (!id || !document.getElementById(id)) return;
        if (!samePageAsHref(href) && href.indexOf("#") !== 0) return;
        e.preventDefault();
        if (mobileOverlay?.contains(link)) closeOverlay(mobileOverlay);
        requestAnimationFrame(() => scrollToSection(id));
      });
    });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".overlay.expanded").forEach((overlay) => {
      closeOverlay(overlay);
    });
  });

  syncHeaderStackHeight();
  window.addEventListener("resize", syncHeaderStackHeight);
})();
